import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import router from '@/router';
import { adminAuthStore } from '@/stores/adminAuthStore';
import { GET_API_URL, apiStatus } from '@/shared/constans';

let adminAxios: AxiosInstance | null = null;
let adminRefreshPromise: Promise<string> | null = null;

const ADMIN_TOKEN_EXCLUDE = [
  '/admin/auth/bootstrap',
  '/admin/auth/login',
  '/admin/auth/refresh',
];

function getBaseURL(): string {
  const url = GET_API_URL();
  return url || '';
}

async function refreshAdminToken(): Promise<string> {
  if (adminRefreshPromise) return adminRefreshPromise;
  const store = adminAuthStore();
  adminRefreshPromise = (async () => {
    if (!store.refresh) return '';
    const res = await adminApi().post(
      '/admin/auth/refresh',
      {},
      {
        headers: {
          Authorization: store.refresh,
        },
      },
    );
    if (res.status === apiStatus.SUCCESS) {
      store.setTokens(res.data);
      return store.key;
    }
    return '';
  })();
  adminRefreshPromise.finally(() => {
    adminRefreshPromise = null;
  });
  return adminRefreshPromise;
}

export function adminApi(): AxiosInstance {
  if (adminAxios) return adminAxios;
  adminAxios = axios.create({
    baseURL: getBaseURL(),
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    } as AxiosRequestHeaders,
  });

  adminAxios.interceptors.request.use(
    (config: any) => {
      const store = adminAuthStore();
      if (!ADMIN_TOKEN_EXCLUDE.includes(config.url) && store.key) {
        config.headers.Authorization = store.key;
      }
      return config;
    },
    (err) => Promise.reject(err),
  );

  adminAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { response, config } = error || {};
      const store = adminAuthStore();

      if (response?.status === 401) {
        try {
          const newKey = await refreshAdminToken();
          if (newKey) {
            const retryConfig = { ...config };
            retryConfig.headers = { ...(retryConfig.headers || {}), Authorization: newKey };
            return adminAxios!(retryConfig);
          }
        } catch {
          // fallthrough to logout
        }
        store.reset();
        if (router.currentRoute.value.path !== '/inspirio-inc-admin/login') {
          router.replace('/inspirio-inc-admin/login');
        }
      }
      return Promise.reject(error);
    },
  );

  return adminAxios;
}


